import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssinaturaService } from '../../../core/services/assinatura.service';
import { Assinatura } from '../../../core/models/assinatura';
import { MessageService, ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-assinatura-detail',
  templateUrl: './assinatura-detail.component.html',
  styleUrls: ['./assinatura-detail.component.scss'],
})
export class AssinaturaDetailComponent implements OnInit {
  assinatura?: Assinatura;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private service: AssinaturaService,
    private message: MessageService,
    private confirmation: ConfirmationService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) this.load(id);
  }

  load(id: string) {
    this.loading = true;
    this.service.getById(id).subscribe({
      next: (res: Assinatura) => (this.assinatura = res),
      error: () => this.message.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar' }),
      complete: () => (this.loading = false),
    });
  }

  voltar() {
    this.router.navigate(['/assinaturas']);
  }

  editar() {
    if (!this.assinatura?.id) return;
    this.router.navigate(['/assinaturas', this.assinatura.id, 'editar']);
  }
}
